import AdministrationRoutes from './AdministrationRoutes';
import AuthRoutes from './AuthRoutes';
import EventsRoutes from './EventsRoutes';
import FocaRoutes from './FocaRoutes';
import PpmRoutes from './PpmRoutes';
import ReconocimientosRoutes from './Reconocimientos';

const Routes = [...AuthRoutes, ...AdministrationRoutes, ...EventsRoutes, ...FocaRoutes, ...PpmRoutes, ...ReconocimientosRoutes];

export { Routes };
